import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "Inter";
    src: url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
  }

  html, body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    min-height: 100vh;
    font-family: 'Inter', sans-serif;
  }
  * {
    box-sizing: border-box;
  }
  a {
    text-decoration: none;
  }
  #root{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  html{
    font-size: 56%;
    background-color: ${(props) =>
      props.theme.type === 'light'
        ? props.theme.colors.white[500]
        : props.theme.colors.black[900]};
    .MuiButton-root {
      box-shadow: none !important;
      &.MuiButton-outlinedPrimary {
        border-width: 2px;
      }
    }
  }

  div{
    &#root{
      padding: 0;
    }
  }


  .MuiIconButton-root {
    color: inherit !important;
  }

  @media (max-width: 1080) {
    html {
      font-size: 58%;
    }
  }

  @media (max-width: 600px) {
    html{
      font-size: 50%;
    }
  }

  p {
    font-size: 1.4rem;
  }
  
  @font-face {
    font-family: "EuropaBold";
    src: url("/fonts/EuropaBold/EuropaBold.ttf");
    font-style: normal;
    font-weight: bold;
    font-display: swap;
  }

  .Toastify__toast-body{
    font-size: 1.6rem;
  }

  & .react-select__menu-portal{
    font-size: 1.6rem;
    z-index: 2000 !important;
    .react-select__menu {
      z-index: 2000;
    }
  }

  @font-face {
    font-family: 'Material Icons';
    font-style: normal;
    font-weight: 400;
    src: url("https://fonts.gstatic.com/s/materialicons/v109/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2") format('woff2');
  }

  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-smoothing: antialiased;
  }
`;
